import { AuthenticationService } from 'src/services/authentication/authentication.service';

// Roles and permissions are fetched and added to the user object coming from the ID token
export const addUserAccessToToken = async (decodedIdToken: string): Promise<string> => {
  const { accessRoles, billingAdminCustomers, integratorCustomers } =
    await AuthenticationService.getUserAccess();

  return JSON.stringify({
    ...JSON.parse(decodedIdToken),
    access_roles: JSON.stringify(accessRoles),
    billing_admin_customers: JSON.stringify(billingAdminCustomers),
    integrator_customers: JSON.stringify(integratorCustomers),
  });
};
